<hpf-text-translated-form
        [textTranslated]="textTranslated"
        [loading]="textTranslated.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-text-translated-form>
<div class="container">
</div>
